import type React from 'react';

/** Peças visuais do detalhe da empresa no layout de 10/2026. */
export const CAIXA: React.CSSProperties = {
  minWidth: 0,
  padding: '14px 16px',
  borderRadius: 12,
  border: '1px solid #E4E4E7',
  background: 'rgba(255, 255, 255, .6)',
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
};

export const TITULO: React.CSSProperties = { fontSize: 14, fontWeight: 700 };
export const SUB: React.CSSProperties = { fontSize: 11.5, color: '#52525B' };

export const ROTULO: React.CSSProperties = {
  fontSize: 10.5,
  fontWeight: 600,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: '#64748B',
};

export const pilula = (fundo: string, cor: string): React.CSSProperties => ({
  padding: '2px 9px',
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 700,
  whiteSpace: 'nowrap',
  background: fundo,
  color: cor,
});

export const TH: React.CSSProperties = { padding: '8px 10px', fontWeight: 600 };
export const CABECA_DA_TABELA: React.CSSProperties = {
  textAlign: 'left',
  color: '#52525B',
  fontSize: 10.5,
  textTransform: 'uppercase',
  letterSpacing: '.05em',
};

export const BOTAO_AZUL: React.CSSProperties = {
  height: 36,
  padding: '0 16px',
  border: 0,
  borderRadius: 8,
  background: '#1B6FD0',
  color: '#FFFFFF',
  fontSize: 12.5,
  fontWeight: 600,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 7,
  whiteSpace: 'nowrap',
};

export const LINK: React.CSSProperties = {
  border: 0,
  background: 'transparent',
  padding: 0,
  color: '#1B6FD0',
  fontSize: 12,
  fontWeight: 600,
  textDecoration: 'underline',
  cursor: 'pointer',
};

/** Variação com seta: verde para cima, vermelho para baixo, cinza sem base. */
export const delta = (
  d: number | null,
  texto: string,
): { texto: string; cor: string; fundo: string } => {
  if (d == null) return { texto: '—', cor: '#475569', fundo: '#EEF2F6' };
  if (d > 0) return { texto: `▲ ${texto}`, cor: '#15803D', fundo: '#DCFCE7' };
  if (d < 0) return { texto: `▼ ${texto}`, cor: '#B91C1C', fundo: '#FEE2E2' };
  return { texto: `= ${texto}`, cor: '#475569', fundo: '#EEF2F6' };
};
